import { render, staticRenderFns } from "./TransferOwnershipDialogue.vue?vue&type=template&id=3b8774c3&scoped=true&"
import script from "./TransferOwnershipDialogue.vue?vue&type=script&lang=js&"
export * from "./TransferOwnershipDialogue.vue?vue&type=script&lang=js&"
import style0 from "./TransferOwnershipDialogue.vue?vue&type=style&index=0&id=3b8774c3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8774c3",
  null
  
)

export default component.exports